"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.paintStatesComplete = exports.paintSystemComplete = exports.paintFlagComplete = void 0;
exports.surfacePaintStates = surfacePaintStates;
exports.measuredPaintStates = measuredPaintStates;
const pricing_inputs_ts_1 = require("./pricing-inputs.js");
const pricing_ts_1 = require("./pricing.js");
const surface_rows_ts_1 = require("./surface-rows.js");
/**
 * A flagged surface is resolved once its own paint isn't the option's standard one, or it has a paint system on any
 * paint: the first line may be prep under a two-pack system, left on standard (MJ, DD 29 Oct).
 */
const paintFlagComplete = (choice) => !!choice?.paint || (choice?.systems?.length ?? 0) > 0;
exports.paintFlagComplete = paintFlagComplete;
/** A paint system is complete with a name and hours above 0 (as priced); its paint may be standard (MJ, DD 29 Oct). */
const paintSystemComplete = (system, hours) => !!system.name?.trim() && hours > 0;
exports.paintSystemComplete = paintSystemComplete;
/** The surface's states; `systemHours` gives each system's hours by its row id (systemRowId). */
function surfacePaintStates(surfaceId, flagged, choice, systemHours) {
    const systems = choice?.systems ?? [];
    return {
        ...(flagged && { flag: (0, exports.paintFlagComplete)(choice) }),
        ...(systems.length > 0 && { systems: systems.every((x) => (0, exports.paintSystemComplete)(x, systemHours((0, surface_rows_ts_1.systemRowId)(surfaceId, x.id)))) }),
    };
}
/** The label's tick and the line's edge: green only when everything on it is complete; undefined with nothing to finish. */
const paintStatesComplete = (states) => states.flag === undefined && states.systems === undefined ? undefined : states.flag !== false && states.systems !== false;
exports.paintStatesComplete = paintStatesComplete;
/** The same for a measured surface away from the Take Off (the Measure card): its systems' hours worked out as pricing does. */
function measuredPaintStates(doc, surface, type, choice) {
    const rows = choice?.systems?.length ? (0, pricing_inputs_ts_1.surfaceInOption)(doc, surface, type, choice).rows : [];
    const hours = new Map(rows.map((row) => [row.id, (0, pricing_ts_1.surfaceWork)(row).hours]));
    return surfacePaintStates(surface.id, surface.paintFlag !== undefined, choice, (id) => hours.get(id) ?? 0);
}
